import classNames from "classnames"
import type { ReactNode } from "react"

export interface Props {
  left: ReactNode
  right: ReactNode
  gap?: number
  className?: string
}

const gapClasses: Record<number, string> = {
  0: "gap-0",
  1: "gap-1",
  2: "gap-2",
  3: "gap-3",
  4: "gap-4",
  5: "gap-5",
  6: "gap-6",
  7: "gap-7",
  8: "gap-8",
  9: "gap-9",
  10: "gap-10",
  12: "gap-12",
  16: "gap-16"
}

const TwoColumnLayout = ({ left, right, gap = 8, className }: Props) => {
  const gapClass = gapClasses[gap] ?? "gap-8"

  return (
    <div
      className={classNames("flex flex-col lg:flex-row", gapClass, className)}
    >
      <div className="w-full lg:w-[55%]">{left}</div>
      <div className="w-full lg:w-[45%]">{right}</div>
    </div>
  )
}

TwoColumnLayout.displayName = "TwoColumnLayout"

export { TwoColumnLayout }
export default TwoColumnLayout
